import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { ISmevResend } from './interfaces/ISmevResend';

export const controlOfNewsLetterTableColumns: ITableColumn<ISmevResend>[] = [
  {
    id: 'erpId',
    name: 'Учётный номер паспорта',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
    style: { flex: '1 1 20%' },
  },
  {
    id: 'creationDate',
    name: 'Дата паспорта',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
    style: { flex: '1 1 12%' },
  },
  {
    id: 'sendingDate',
    name: 'Дата отправки в СМЭВ',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
    style: { flex: '1 1 17%' },
  },
  {
    id: 'lastAttemptDate',
    name: 'Дата и время последней попытки',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
    style: { flex: '1 1 20%' },
  },
  {
    id: 'timeOfDelay',
    name: 'Время просрочки отправки в часах',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
    style: { flex: '1 1 23%' },
  },
  {
    id: 'attemptCount',
    name: 'Количество попыток',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
    style: { flex: '1 1 14%' },
  },
];
